/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Model_Settings_Chip2_LabelInputs */



/**
* | output |
* | --- |
* | "What does the reasoning level change?" |
*
* @param {Uno_Edu_Chat_Model_Settings_Chip2_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_model_settings_chip2_label = /** @type {((inputs?: Uno_Edu_Chat_Model_Settings_Chip2_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Model_Settings_Chip2_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Was ändert das Reasoning-Level?")
	return /** @type {LocalizedString} */ ("What does the reasoning level change?")
});